module.exports = __webpack_public_path__ + "img/MLK flagpole image 1.0a225039.png";